import React from 'react';
import { InfoWindow } from '@react-google-maps/api';

export default function CustomInfoWindow(props) {
    return <div className="card" style={{ width: '200px' }} >{props.children}</div>;
}

export const getInfoWindow = (props, inner) => {
    if (props.nogoogle) {
        return (
            <CustomInfoWindow position={props.OverridePosition || props.Position || props.Positions.offsite}
                options={{ pixelOffset: { height: '-3' } }}
                onCloseClick={props.onCloseClick}>
                {inner}
            </CustomInfoWindow>);

    } else {
        return (
            <InfoWindow position={props.OverridePosition || props.Position}
                options={{ pixelOffset: { height: '-3' } }}
                onCloseClick={props.onCloseClick}>
                {inner}
            </InfoWindow>
        );
    }
};
